import { Cache } from '../cache';
import { MessageUtils } from '../errors';
import { UserUtils } from '../userinfo';

const initialApp = async () => {
  await new Promise((resolve) => {
    Cache.addInitDoneListeners((e: string) => {
      resolve(e);
    });
  });
  await Promise.all([UserUtils.init(), MessageUtils.init()]);
};
export { initialApp };
